import { FC } from 'react';
import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  Typography,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Project } from './CardsData';

export interface CardProps {
  data: Project;
}

const CustomCard: FC<CardProps> = ({ data }) => {
  return (
    <Link
      to={`/docs/default/resource/architecture-center/${data.urlSuffix}`}
      target="_blank"
    >
      <Card>
        <CardActionArea>
          <CardMedia
            component="img"
            alt={data.title}
            height="140"
            image={data.image}
            title={data.title}
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              {data.title}
            </Typography>
            <Typography variant="body1" gutterBottom>
              {data.description}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Tags: {data.tags.join(' | ')}
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button size="small" color="primary">
            Learn More
          </Button>
        </CardActions>
      </Card>
    </Link>
  );
};

export default CustomCard;
